export default __webpack_public_path__ + "static/media/cdmx_c.a56342b3.jpg";